import { lazy } from "react";
import AppIcons from "../../components/Base/AppIcons/AppIcons";
import routesRecargaCupoWithPasarela from "./Pasarelas/routes";
import { ListPermissionsRecargaCupoWithPasarela } from "./Pasarelas/ListPermissionsRecargaCupoWithPasarela";

const RecargaCupoMenu = lazy(() => import("./RecargaCupoMenu"));

const routesRecargaCupo = {
  link: "/recarga-cupo",
  label: <AppIcons Logo={"RECARGA_CELULAR"} name="Recargar Cupo" />,
  component: RecargaCupoMenu,
  permission: [
    ListPermissionsRecargaCupoWithPasarela.RECARGA_CUPO_CON_GOU,
    ListPermissionsRecargaCupoWithPasarela.RECARGA_CUPO_CON_EVERTEC,
  ],
  subRoutes: [...routesRecargaCupoWithPasarela],
};

export default routesRecargaCupo;
